function SvgCanopy(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 90 65"
      {...props}
    >
      <path d="M87.862 60.846h-6.126V24.343c0-.101-.008-.2-.022-.296a2.049 2.049 0 00-.658-1.819L56.996.577A2.053 2.053 0 0055.624.05h-20.99c-.496 0-.976.18-1.35.507L8.495 22.208a2.055 2.055 0 00-.681 1.838 2.101 2.101 0 00-.022.298v36.503H2.139a1.81 1.81 0 000 3.618h85.723a1.81 1.81 0 000-3.619zM11.897 25.804h21.361v34.503H11.897V25.804zm25.464 0h14.805v34.503H37.361V25.804zm0-21.148h14.805v17.045H37.361V4.656zM56.27 25.804h21.361v34.503H56.27V25.804zm18.066-4.103H56.27V5.444l18.066 16.257zM33.258 6.028v15.673H15.314L33.258 6.028z" />
    </svg>
  );
}

export default SvgCanopy;
